/**
 * ScreenShell — Reusable wrapper for screen layout (meta bar + content).
 * Eliminates 17× repeated screen/meta/content JSX wrapper.
 *
 * Usage:
 *   <ScreenShell label="Permissions" onBack={handleBack} testId="permissions-screen">
 *     {children}
 *   </ScreenShell>
 */
import styles from "../styles/screen-atoms.module.css";

type Props = {
  label?: string;
  onBack?: () => void;
  metaRight?: React.ReactNode;
  testId?: string;
  children: React.ReactNode;
};

export function ScreenShell({ label, onBack, metaRight, testId, children }: Props) {
  return (
    <div className={styles.screen} data-testid={testId}>
      {(label || onBack || metaRight) && (
        <div className={onBack || metaRight ? styles.metaSpaceBetween : styles.metaCentered}>
          {onBack && (
            <button className={styles.backBtn} onClick={onBack} type="button">
              ← back
            </button>
          )}
          {label && <span className={styles.metaLabel}>{label}</span>}
          {metaRight && <div>{metaRight}</div>}
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
}
